import Profissional from "../models/Profissional";

export default class PlanoManutencao {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.detalhe = "Equipamento Eletromecânico";
    this.objetivo =
      "Este plano de manutenção tem o objetivo de evitar falhas, provocadas pelo uso do equipamento e pelo avanço da sua vida útil operacional. Além disso, cria um histórico das manutenções, organizando e prevendo as próximas ações que deveram ser tomadas para o uso seguro e eficiente do equipamento.";
    this.local = "Base da Netech / Mossoró-RN";
    this.resultado = "APROVADO";
    this.servicos = [];
    this.itens = this.getDefaultItens();
    this.observacao =
      "A inspeção do local e das condições de segurança do local devem ser feitas toda vez antes de utilizá-lo, a fim de garantir a preservação da saúde  do colaborador. Os operadores desse equipamento devem ser devidamente qualificados e legalmente habilitados, os trabalhadores devem porta crachá de  identificação e qualificação, do qual conste a data do seu último exame médico ocupacional e treinamento realizado.";
    this.inspetor = new Profissional();
    this.responsavel = new Profissional();
  }

  getDefaultItens() {
    let list = [];
    for (let index = 1; index < 10; index++) {
      list.push({
        item: "- - -",
        intervalo: "- - -",
        historico: this.getDefaultHistorico(),
      });
    }
    return list;
  }

  getDefaultHistorico() {
    let historico = [];
    for (let index = 1; index < 6; index++) {
      historico.push({
        id: index,
        data: new Date(),
      });
    }
    return historico;
  }

  setHistorico() {
    this.itens.forEach((item) => {
      item.historico = [];
      this.servicos.forEach((servico) => {
        item.historico.push({ id: servico.id, data: servico.data });
      });
      item.historico.reverse();
      while (item.historico.length > 5) {
        item.historico.pop();
      }
    });
  }
}
